"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PercentageLabel = _styledComponents.default.div(function (_ref) {
  var percentage = _ref.percentage,
      colors = _ref.theme.colors;
  return "\n  width: 80px;\n  height: 20px;\n  border: 1px solid ".concat(colors.aqua100, ";\n  border-radius: 5px;\n  background-color: white;\n  display: flex;\n  position:relative;\n  \n  &:before {\n    content: '';\n    width: ").concat(percentage * 78 / 100, "px;\n    height: 18px;\n    background: rgb(255, 215, 208);\n    position: absolute;\n    border-radius: 4px 0 0 4px;\n  }\n  \n  &:after {\n    content: '").concat(percentage, "%';\n    line-height: 14px;\n    position: absolute;\n    padding-top: 3px;\n    color: ").concat(colors.main, ";\n    font-weight: bold;\n    font-family: 'Lato', sans-serif;\n    font-size: 12px;\n    width: 80px;\n    text-align: center;\n  }\n");
});

var _default = function _default(_ref2) {
  var _ref2$percentage = _ref2.percentage,
      percentage = _ref2$percentage === void 0 ? 0 : _ref2$percentage;
  return _react.default.createElement(PercentageLabel, {
    percentage: percentage
  });
};

exports.default = _default;